import React, { useEffect, useState } from "react";

/** A post's reference, as Rustle It support searches for it (the database id). */
export const postRef = (id: number) => `P-${id}`;
/** A report's reference, as Rustle It support searches for it (the database id). */
export const reportRef = (id: number) => `R-${id}`;

/**
 * "Ref P-1234" with a copy button. Shown to all staff, all the time: whoever
 * spots a problem can quote it in a support email instead of describing the
 * record, and support (who never see content) can open it directly. The id
 * means nothing outside the app.
 */
interface SupportRefProps {
  code: string;
  className?: string;
  /** A `data-help` anchor, so the Contact support How To can point at it. */
  dataHelp?: string;
}

const SupportRef: React.FC<SupportRefProps> = ({ code, className, dataHelp }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
    } catch {
      // Clipboard blocked (e.g. not a secure context): the code is still selectable.
    }
  };

  return (
    <span
      className={`support-ref${className ? ` ${className}` : ''}`}
      title="Quote this reference if you contact support about it"
      data-help={dataHelp}
    >
      Ref <span className="support-ref__code">{code}</span>
      <button type="button" className="support-ref__copy" onClick={copy} aria-label={`Copy reference ${code}`}>
        <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`} aria-hidden />
      </button>
    </span>
  );
};

export default SupportRef;
